
// import React from "react";
// import ReactDOM from "react-dom";
// import { BrowserRouter } from "react-router-dom";
// import App from "./App";

// const maxReloads = 1;
// const reloadCount = sessionStorage.getItem('reloadCount') || 0;

// if (reloadCount < maxReloads) {
//   sessionStorage.setItem('reloadCount', Number(reloadCount) + 1);
//   window.location.reload();
// } else {
//   console.error('ChunkLoadError: Maximum reload attempts reached.');
// }

// window.addEventListener('error', (e) => {
//   if (e?.message?.includes('ChunkLoadError')) {
//     window.location.reload(); // force refresh
//   }
// });

// ReactDOM.render(
//   <BrowserRouter>
//     <App />
//   </BrowserRouter>,
//   document.getElementById("root"),
// );


import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";

const maxReloads = 1;
const reloadCount = Number(sessionStorage.getItem("reloadCount") || 0);

if (reloadCount < maxReloads) {
  sessionStorage.setItem("reloadCount", reloadCount + 1);
  window.location.reload();
} else {
  console.error("ChunkLoadError: Maximum reload attempts reached.");
}

window.addEventListener("error", (e) => {
  if (e?.message?.includes("ChunkLoadError")) {
    window.location.reload();
  }
});

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
